var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.counts,"footer-props":{
      'items-per-page-options': [10,25,100]
    }},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(new Date(item.date).toLocaleString("de-DE"))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }